// extracted by mini-css-extract-plugin
module.exports = {"container":"_1A3xR","title":"_1hQqj","download":"_3L2Mm"};